import React, { useEffect, useState } from "react";
import { Checkbox, FormControl, Input, ListItemText, MenuItem, Select } from "@material-ui/core";

const MENU_PROPS = { PaperProps: { style: { maxHeight: 48 * 4.5 + 8, width: 250 } } };
const INPUT = <Input />;

// material-table's built-in lookup filter lists Object.keys(lookup), which JS always
// sorts numerically for integer ids. This one follows columnDef.lookupOrder instead.
const OrderedLookupFilter = ({ columnDef, onFilterChanged, forwardedRef }) => {
  const [selected, setSelected] = useState(columnDef.tableData.filterValue || []);

  useEffect(() => {
    setSelected(columnDef.tableData.filterValue || []);
  }, [columnDef.tableData.filterValue]);

  const keys = columnDef.lookupOrder || Object.keys(columnDef.lookup);

  return (
    <FormControl style={{ width: "100%" }} ref={forwardedRef}>
      <Select
        multiple
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        onClose={() => onFilterChanged(columnDef.tableData.id, selected)}
        input={INPUT}
        renderValue={(values) => values.map((key) => columnDef.lookup[key]).join(", ")}
        MenuProps={MENU_PROPS}
      >
        {keys.map((key) => (
          <MenuItem key={key} value={key}>
            <Checkbox checked={selected.includes(key)} />
            <ListItemText primary={columnDef.lookup[key]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OrderedLookupFilter;
